// extracted by mini-css-extract-plugin
var _1 = "RentalPortalOverviewAttentionRow-modulecover__kURkR";
export { _1 as "cover" }
